import { render, staticRenderFns } from "./StudentType.vue?vue&type=template&id=17ade2c8"
import script from "./StudentType.vue?vue&type=script&lang=js"
export * from "./StudentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports